exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info_btn[data-v-769b9bfc] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 12px;\n  width: 12px;\n  min-height: 32px;\n  max-height: 32px;\n}\n.img-btn[data-v-769b9bfc] {\n  width: 50px !important;\n  min-width: 50px !important;\n  max-width: 50px !important;\n}", ""]);

// exports
